import React, { useContext, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import StandardDropdown from '@wix/da-ds/pkg/Dropdown/Preset/StandardDropdown';
import { Props as ThreadHeaderProps } from '../ThreadHeader/ThreadHeader';
import { ThreadOrder, OnOrderChangedFunction } from '../../types';

import s from './ThreadOrderSelect.scss';

export interface Props
  extends Pick<
    ThreadHeaderProps,
    'parentId' | 'commentableTypeId' | 'commentableItemId'
  > {
  streamId: string;
  order?: ThreadOrder;
  onOrderChanged?: OnOrderChangedFunction;
  onOrderChangedDefault: OnOrderChangedFunction;
}

const ThreadOrderSelect: React.FC<Props> = ({
  streamId,
  order,
  onOrderChangedDefault,
  onOrderChanged = onOrderChangedDefault,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const handleOrderChanged = useCallback(
    value => {
      onOrderChanged && onOrderChanged(streamId, value);
    },
    [onOrderChanged, streamId]
  );

  const items = useMemo(
    () => [
      {
        label: t('commentthread.control.newest'),
        value: 'newest',
      },
      {
        label: t('commentthread.control.oldest'),
        value: 'oldest',
      },
    ],
    [t]
  );

  return (
    <div className={s['order-select']}>
      <StandardDropdown
        role="menu"
        placement={isMobile ? 'bottom-end' : 'bottom-start'}
        toggleClassName={s['order-select-toggle']}
        arrowClassName={s['order-select-arrow']}
        selectedValue={order}
        items={items}
        onSelect={handleOrderChanged}
      />
    </div>
  );
};
ThreadOrderSelect.displayName = 'ThreadOrderSelect';

export default ThreadOrderSelect;
